import { ChartRankChange } from './Charts.types';

export const getChartRankChange = (
    currentRank: number,
    lastRank: number | null,
): ChartRankChange => {
    if (lastRank === null || currentRank < lastRank) {
        return ChartRankChange.Up;
    }

    if (currentRank > lastRank) {
        return ChartRankChange.Down;
    }

    return ChartRankChange.None;
};
